
export type ReverseProxyConfig = {
  disableForAll?: boolean;
  disabledTenants?: string[] | null;
};
export const REVERSE_PROXY_CONFIG: ReverseProxyConfig = {
  disableForAll: false,
  disabledTenants: ['testrunner'],
};